<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<modificar-plantilla #modificarplantillahtml (ConfirmoUsuario)="ConfirmoPlantillaHtml($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></modificar-plantilla>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<seleccionararchivo #cargararchivofirmaelectronica [FiltroArchivos]="this.FiltroArchivosFirmaElectronica" [SeleccionMultiple]="true"
                    (SeleccionoArchivo)="this.ArchivoSeleccionado($event)"></seleccionararchivo>

<ng-template #modalfirmaelectronicacampos>
    <mat-dialog-content class="contenedorprincipal">
        <div class="modal-header encabezadomodal">
            <h3 class="d-flex flex-row encabezadomodaltitulo encabezadomodaltitulomargen">
                Campos firma documento: {{this.itemFirmaElectronicaSeleccionado.descripcion}}
            </h3>

            <button type="button" class="confirmacionbotoncerrar" aria-label="Close" [mat-dialog-close]="false">
              <h3 class="encabezadomodaltitulo">X</h3>
            </button>
        </div>
        <div class="contenedorbody">
            <div class="d-flex flex-column">
                <div [formGroup]="formFirmaElectronicaCampos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroFirmaElectronicaCampos">
                    
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Habilitado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo campo (*)</mat-label>
                            <mat-select formControlName="tipoCampo" (ngModelChange)="this.CambioTipoCampo()">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasTipoCampos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('tipoCampo').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mostrar (*)</mat-label>
                            <mat-select formControlName="mostrar">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Código campo (*)</mat-label>
                            <input matInput formControlName="campo" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('campo').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('campo').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Descripción campo (*)</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('descripcion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarValorCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Valor Campo (*)</mat-label>
                            <input matInput formControlName="valorCampo" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('valorCampo').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('valorCampo').hasError('maxlength')">La longitud máxima es 5000</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Orden</mat-label>
                            <input matInput formControlName="orden" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Campo dependiente</mat-label>
                            <input matInput formControlName="campoDependiente" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Requerido (*)</mat-label>
                            <mat-select formControlName="requerido">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12" *ngIf="this.MostrarCodigoCampo() && this.MostrarListaValores()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Lista datos (formato lista codigo=valor=dependiente separado por |, ejemplo: 1=Item1=|2=Item2=)</mat-label>
                            <input matInput formControlName="listaDatos" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('listaDatos').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarCodigoCampo() && this.MostrarListaTopicos()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Lista datos</mat-label>
                            <mat-select formControlName="listaDatos">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaTopicosCamposAdicionales">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formFirmaElectronicaCampos.get('listaDatos').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formFirmaElectronicaCamposCopiar" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroFirmaElectronicaCopiar">
                    
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Configuración copiar (*)</mat-label>
                            <mat-select formControlName="copiarConfiguracion">
                                <mat-option [value]="item.id" *ngFor="let item of this.ListaCamposFirmaElectronica()">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formFirmaElectronicaCamposCopiar.get('copiarConfiguracion').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <div class="p-1">
                        <a type="button" title="Crear nuevo campo" (click)="NuevoFirmaElectronicaCampo()" *ngIf="!editarRegistroFirmaElectronicaCampos && !editarRegistroFirmaElectronicaCopiar" class="accesoAddModal">
                            <mat-icon>add</mat-icon>
                        </a>
                    </div>
                    <div class="p-1">
                        <a type="button" title="Copiar configuración" (click)="NuevoFirmaElectronicaCopiar()" *ngIf="!editarRegistroFirmaElectronicaCampos && !editarRegistroFirmaElectronicaCopiar" class="accesoAddModal">
                            <mat-icon>compare_arrows</mat-icon>
                        </a>
                    </div>
                    <a type="button" class="icnTable" (click)="GuardarFirmaElectronicaCampo()" *ngIf="editarRegistroFirmaElectronicaCampos || editarRegistroFirmaElectronicaCopiar">
                        <mat-icon>save</mat-icon>
                    </a>
                    <a type="button" class="icnTable" (click)="CancelarEditarFirmaElectronicaCampos()" *ngIf="editarRegistroFirmaElectronicaCampos || editarRegistroFirmaElectronicaCopiar">
                        <mat-icon>close</mat-icon>
                    </a>
                </div>
                <div class="mat-elevation-z8 p-0 altofijogrid">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceFirmaElectronicacampos" matSort class="table table-striped table-hover">
                            <ng-container matColumnDef="tipoCampo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo campo</th>
                                <td mat-cell *matCellDef="let row"> {{row.tipoCampo}} </td>
                            </ng-container>
                            <ng-container matColumnDef="campo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Campo</th>
                                <td mat-cell *matCellDef="let row"> {{row.campo}} </td>
                            </ng-container>
                            <ng-container matColumnDef="orden">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Orden</th>
                                <td mat-cell *matCellDef="let row"> {{row.orden}} </td>
                            </ng-container>
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción</th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="mostrar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mostrar</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.mostrar"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.mostrar"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarFirmaElectronicaCampo(row)" *ngIf="!editarRegistroFirmaElectronicaCampos && !editarRegistroFirmaElectronicaCopiar">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarFirmaElectronicaCampo(row)" *ngIf="!editarRegistroFirmaElectronicaCampos && !editarRegistroFirmaElectronicaCopiar">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="AbrirCamposFirmaElectronicaUbicacion(row)" *ngIf="!editarRegistroFirmaElectronica">
                                        <mat-icon>view_list</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoFirmaElectronicaCampos"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoFirmaElectronicaCampos;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorfirmaeletronicacampos [pageSize]="5" [pageSizeOptions]="[5, 10, 15, 20]" aria-label="Select page of users"></mat-paginator>
                </div>
                <div class="d-flex flex-row-reverse pr-0">
                    <div>
                        <button mat-button class="botonguardardatos" [mat-dialog-close]="false">
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                                <span class="botonguardardatostexto">Cerrar</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</ng-template>

<ng-template #modalfirmaelectronicacamposubicacion>
    <mat-dialog-content class="contenedorprincipal">
        <div class="modal-header encabezadomodal">
            <h3 class="d-flex flex-row encabezadomodaltitulo encabezadomodaltitulomargen">
                Ubicación campo: {{this.itemFirmaElectronicaCamposSeleccionado.campo}}
            </h3>

            <button type="button" class="confirmacionbotoncerrar" aria-label="Close" [mat-dialog-close]="false">
              <h3 class="encabezadomodaltitulo">X</h3>
            </button>
        </div>
        <div class="contenedorbody">
            <div class="d-flex flex-column">
                <div [formGroup]="formFirmaElectronicaCamposUbicacion" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroFirmaElectronicaCamposUbicacion">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Posición X</mat-label>
                            <input matInput formControlName="posicionX" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCamposUbicacion.get('posicionX').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Posición Y</mat-label>
                            <input matInput formControlName="posicionY" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCamposUbicacion.get('posicionY').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ancho</mat-label>
                            <input matInput formControlName="ancho" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCamposUbicacion.get('ancho').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tamaño letra</mat-label>
                            <input matInput formControlName="tamanoLetra" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCamposUbicacion.get('tamanoLetra').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Color texto</mat-label>
                            <input matInput formControlName="colorTexto" autocomplete="off">
                            <mat-error *ngIf="formFirmaElectronicaCamposUbicacion.get('colorTexto').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <a type="button" (click)="NuevoFirmaElectronicaCampoUbicacion()" *ngIf="!editarRegistroFirmaElectronicaCamposUbicacion" class="accesoAddModal">
                        <mat-icon>add</mat-icon>
                    </a>
                    <a type="button" class="icnTable" (click)="GuardarFirmaElectronicaCampoUbicacion()" *ngIf="editarRegistroFirmaElectronicaCamposUbicacion">
                        <mat-icon>save</mat-icon>
                    </a>
                    <a type="button" class="icnTable" (click)="CancelarEditarFirmaElectronicaCamposUbicacion()" *ngIf="editarRegistroFirmaElectronicaCamposUbicacion">
                        <mat-icon>close</mat-icon>
                    </a>
                </div>
                <div class="mat-elevation-z8 p-0 altofijogrid">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceFirmaElectronicacamposubicacion" matSort class="table table-striped table-hover">
                            <ng-container matColumnDef="posicionX">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Posición X</th>
                                <td mat-cell *matCellDef="let row"> {{row.posicionX}} </td>
                            </ng-container>
                            <ng-container matColumnDef="posicionY">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Posición Y</th>
                                <td mat-cell *matCellDef="let row"> {{row.posicionY}} </td>
                            </ng-container>
                            <ng-container matColumnDef="ancho">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ancho</th>
                                <td mat-cell *matCellDef="let row"> {{row.ancho}} </td>
                            </ng-container>
                            <ng-container matColumnDef="tamanoLetra">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tamaño letra</th>
                                <td mat-cell *matCellDef="let row"> {{row.tamanoLetra}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarFirmaElectronicaCampoUbicacion(row)" *ngIf="!editarRegistroFirmaElectronicaCamposUbicacion">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarFirmaElectronicaCampoUbicacion(row)" *ngIf="!editarRegistroFirmaElectronicaCamposUbicacion">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoFirmaElectronicaCamposUbicacion"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoFirmaElectronicaCamposUbicacion;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorfirmaeletronicacamposubicacion [pageSize]="5" [pageSizeOptions]="[5, 10, 15, 20]" aria-label="Select page of users"></mat-paginator>
                </div>
                <div class="d-flex flex-row-reverse pr-0">
                    <div>
                        <button mat-button class="botonguardardatos" [mat-dialog-close]="false">
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                                <span class="botonguardardatostexto">Cerrar</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</ng-template>

<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoPlazos()" *ngIf="tabItemSeleccionado === 'tabPrecios' && !editarRegistroPlazos" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoEdades()" *ngIf="tabItemSeleccionado === 'tabEdades' && !editarRegistroEdades" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="AbrirCargarArchivoActualizacion()" *ngIf="(tabItemSeleccionado === 'tabCargaCodigos' && !editarRegistroCodigosActivacion)" class="accesoAdd">
            <mat-icon>cloud_upload</mat-icon>
        </a>
        <a type="button" (click)="NuevoFirmaElectronica()" *ngIf="tabItemSeleccionado === 'tabFirmaDocumentos' && !editarRegistroFirmaElectronica" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoExpedientes()" *ngIf="tabItemSeleccionado === 'tabExpedientes' && !editarRegistroExpedientes" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoEstadosDias()" *ngIf="tabItemSeleccionado === 'tabEstadosDias' && !editarRegistroEstadosDias" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoCampos()" *ngIf="tabItemSeleccionado === 'tabCampos' && !editarRegistroCampos" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoCamposBeneficiarios()" *ngIf="tabItemSeleccionado === 'tabCamposBeneficiarios' && !editarRegistroCamposBeneficiarios" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoNotificaciones()" *ngIf="tabItemSeleccionado === 'tabNotificaciones' && !editarRegistroNotificaciones" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabPrecios' && editarRegistroPlazos">
            <a type="button" class="icnTable" (click)="GuardarPlazos()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarPlazos()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabEdades' && editarRegistroEdades">
            <a type="button" class="icnTable" (click)="GuardarEdades()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarEdades()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="((tabItemSeleccionado === 'tabCargaCodigos' && editarRegistroCodigosActivacion))">
            <a type="button" class="icnTable" (click)="GuardarCodigosActivacion()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarCodigosActivacion()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabFirmaDocumentos' && editarRegistroFirmaElectronica">
            <a type="button" class="icnTable" (click)="GuardarFirmaElectronica()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarFirmaElectronica()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabExpedientes' && editarRegistroExpedientes">
            <a type="button" class="icnTable" (click)="GuardarExpediente()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarExpedientes()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabEstadosDias' && editarRegistroEstadosDias">
            <a type="button" class="icnTable" (click)="GuardarEstadosDias()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarEstadosDias()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabCampos' && editarRegistroCampos">
            <a type="button" class="icnTable" (click)="GuardarCampos()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarCampos()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabCamposBeneficiarios' && editarRegistroCamposBeneficiarios">
            <a type="button" class="icnTable" (click)="GuardarCamposBeneficiarios()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarCamposBeneficiarios()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabNotificaciones' && editarRegistroNotificaciones">
            <a type="button" class="icnTable" (click)="GuardarNotificaciones()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarNotificaciones()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab label="tabInformacion">
            <ng-template mat-tab-label>
                <span>Información</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Cliente (*)</mat-label>
                        <mat-select formControlName="aliado" (ngModelChange)="Cambio_Aliado()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasAliados">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('aliado').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Sponsor o canal (*)</mat-label>
                        <mat-select formControlName="canal">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasCanalesSeleccion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('canal').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Comercialización (*)</mat-label>
                        <mat-select formControlName="comercializacion" (ngModelChange)="Cambio_Comercializacion()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasComercializacion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('comercializacion').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="habilitado">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Tipo de valoración de afiliación (*)</mat-label>
                        <mat-select formControlName="tipoAfiliacion" (ngModelChange)="Cambio_TipoVigencia()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasTipoVinculacion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('tipoAfiliacion').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre (*)</mat-label>
                        <input matInput formControlName="descripcion" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('descripcion').hasError('required')">Campo requerido</mat-error>
                        <mat-error *ngIf="form.get('descripcion').hasError('maxlength')">La longitud máxima es 50</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Código equivalente aliado</mat-label>
                        <input matInput formControlName="compra" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('compra').hasError('maxlength')">La longitud máxima es 6</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Código ERP</mat-label>
                        <input matInput formControlName="equivalencia" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('equivalencia').hasError('maxlength')">La longitud máxima es 6</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Cambiar producto (*)</mat-label>
                        <mat-select formControlName="idReasignar" (ngModelChange)="Cambio_IdReasignar()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasProductos">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarMesesReasignar()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Meses nuevo producto <span *ngIf="form.get('mesesReasignar').hasError('min')">(*)</span></mat-label>
                        <input matInput formControlName="mesesReasignar" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('mesesReasignar').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Imagen</mat-label>
                        <input matInput formControlName="imagen" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('imagen').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Url terminos y condiciones</mat-label>
                        <input matInput formControlName="terminoscondiciones" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('terminoscondiciones').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Control de operaciones</mat-label>
                        <input matInput formControlName="rutaControlOperaciones" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('rutaControlOperaciones').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Notificación SMS</mat-label>
                        <mat-select formControlName="notificacionSMS">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Notificación Email</mat-label>
                        <mat-select formControlName="notificacionEmail">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Conservación</mat-label>
                        <mat-select formControlName="conservacion">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registrar beneficiarios</mat-label>
                        <mat-select formControlName="registrarBeneficiarios">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarBeneficiariosRequerido()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Beneficiarios requerido</mat-label>
                        <mat-select formControlName="beneficiariosrequeridos">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registra fecha nacimiento</mat-label>
                        <mat-select formControlName="manejaFechaNacimiento">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarRegistrarFechaNacimiento()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Edad minima</mat-label>
                        <input matInput formControlName="edadMinima" autocomplete="off" type="number">
                        <mat-error *ngIf="form.get('edadMinima').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarRegistrarFechaNacimiento()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Edad maxima</mat-label>
                        <input matInput formControlName="edadMaxima" autocomplete="off" type="number">
                        <mat-error *ngIf="form.get('edadMaxima').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registra domicilio</mat-label>
                        <mat-select formControlName="manejaDomicilio">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registra observaciones</mat-label>
                        <mat-select formControlName="manejaObservaciones">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarIngresoPrecioManual()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Precio base (*)</mat-label>
                        <input matInput formControlName="montobase" autocomplete="off" type="number" (ngModelChange)="Calcular_Valor()">
                        <mat-error *ngIf="form.get('montobase').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarIngresoPrecioManual()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>IVA (*)</mat-label>
                        <mat-select formControlName="ivaimpuesto" (ngModelChange)="Calcular_Valor()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasImpuestos">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('ivaimpuesto').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarIngresoPrecioManual()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>IVA base</mat-label>
                        <input matInput formControlName="ivabase" autocomplete="off" type="number" [readonly]="true">
                        <mat-error *ngIf="form.get('ivabase').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarIngresoPrecioManual()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Precio IVA incluido (*)</mat-label>
                        <input matInput formControlName="precio" autocomplete="off" type="number" (ngModelChange)="Cambio_Precio()">
                        <mat-error *ngIf="form.get('precio').hasError('min')">Campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Operaciones reembolso</mat-label>
                        <mat-select formControlName="operacionesReembolso">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Programa expedientes</mat-label>
                        <mat-select formControlName="programaSara">
                            <mat-option [value]="item.id" *ngFor="let item of this.listasProgramasExpedientes">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Solicitar tomador</mat-label>
                        <mat-select formControlName="tomador">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Duplicar titular</mat-label>
                        <mat-select formControlName="duplicarTitular">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Url notificaciones</mat-label>
                        <input matInput formControlName="urlNotificacion" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('urlNotificacion').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Linea nacional</mat-label>
                        <input matInput formControlName="lineaNacional" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('lineaNacional').hasError('maxlength')">La longitud máxima es 200</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nro fijo</mat-label>
                        <input matInput formControlName="nroFijo" autocomplete="off" type="text">
                        <mat-error *ngIf="form.get('nroFijo').hasError('maxlength')">La longitud máxima es 200</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarRegistrarFechaNacimiento() && HabilitarDatosTomador()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Edad mínima tomador</mat-label>
                        <input matInput formControlName="edadMinimaTomador" autocomplete="off" type="number">
                        <mat-error *ngIf="form.get('edadMinimaTomador').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarRegistrarFechaNacimiento() && HabilitarDatosTomador()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Edad maxima tomador</mat-label>
                        <input matInput formControlName="edadMaximaTomador" autocomplete="off" type="number">
                        <mat-error *ngIf="form.get('edadMaximaTomador').hasError('maxlength')">La longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registrar estado</mat-label>
                        <mat-select formControlName="registrarEstado">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Estado dependiente día mes</mat-label>
                        <mat-select formControlName="estadoDependienteFecha">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarRegistrarEstado()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Permitir editar registro</mat-label>
                        <mat-select formControlName="permiteEditar">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Firma electronica</mat-label>
                        <mat-select formControlName="firmaElectronica" (ngModelChange)="Cambio_FirmaElectronica()">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Programacion precios</mat-label>
                        <mat-select formControlName="programacionPrecios">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ruta registro fotografico</mat-label>
                        <input matInput formControlName="rutaRegistroFotografico" autocomplete="off" type="text">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Cantidad años modelo</mat-label>
                        <input matInput formControlName="cantidadAnnosModelo" autocomplete="off" type="number">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ruta registro expedientes</mat-label>
                        <input matInput formControlName="rutaRegistroExpedientes" autocomplete="off" type="text">
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabPrecios" *ngIf="HabilitarIngresoVigencia()">
            <ng-template mat-tab-label>
                <span>Periodos del programa</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formPlazos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroPlazos">
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formPlazos.get('id').value > 0">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Nombre vigencia (*)</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off">
                            <mat-error *ngIf="formPlazos.get('descripcion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formPlazos.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Número de meses (*)</mat-label>
                            <input matInput formControlName="plazoMeses" autocomplete="off" type="number">
                            <mat-error *ngIf="formPlazos.get('plazoMeses').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Sin meses cobro (*)</mat-label>
                            <mat-select formControlName="sinMesesCobro" (ngModelChange)="Cambio_SinMesesCobro()">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarMesesCobro()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Meses cobro (*)</mat-label>
                            <input matInput formControlName="mesesCobro" autocomplete="off" type="number" (ngModelChange)="Cambio_MesesPlazo('CAMBIOMESES', $event)">
                            <mat-error *ngIf="formPlazos.get('mesesCobro').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formPlazos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroPlazos">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio base (*)</mat-label>
                            <input matInput formControlName="montobase" autocomplete="off" type="number" (focusout)="Cambio_ValorPlazo('PRECIOBASE', $event)">
                            <mat-error *ngIf="formPlazos.get('montobase').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>IVA (*)</mat-label>
                            <mat-select formControlName="ivaimpuesto" (ngModelChange)="Calcular_ValorPlazo('CAMBIOIVA', 0)">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasImpuestos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formPlazos.get('ivaimpuesto').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formPlazos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroPlazos">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>IVA base</mat-label>
                            <input matInput formControlName="ivabase" autocomplete="off" type="number" [readonly]="true">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio IVA incluido (*)</mat-label>
                            <input matInput formControlName="precio" autocomplete="off" type="number" [readonly]="true">
                            <mat-error *ngIf="formPlazos.get('precio').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarMesesCobro()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio Total IVA incluido (*)</mat-label>
                            <input matInput formControlName="total" autocomplete="off" type="number" [readonly]="true">
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formPlazos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroPlazos">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio base con beneficiario (*)</mat-label>
                            <input matInput formControlName="montobaseconbeneficiario" autocomplete="off" type="number" (focusout)="Cambio_ValorPlazoBeneficiario('PRECIOBASE', $event)">
                            <mat-error *ngIf="formPlazos.get('montobaseconbeneficiario').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>IVA con beneficiario (*)</mat-label>
                            <mat-select formControlName="ivaimpuestoconbeneficiario" (ngModelChange)="Calcular_ValorPlazoConBeneficiario('CAMBIOIVA', 0)">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasImpuestos">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formPlazos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroPlazos">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>IVA base con beneficiario</mat-label>
                            <input matInput formControlName="ivabaseconbeneficiario" autocomplete="off" type="number" [readonly]="true">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio IVA incluido con beneficiario (*)</mat-label>
                            <input matInput formControlName="precioconbeneficiario" autocomplete="off" type="number" [readonly]="true">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarMesesCobro()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio Total IVA incluido con beneficiario (*)</mat-label>
                            <input matInput formControlName="totalconbeneficiario" autocomplete="off" type="number" [readonly]="true">
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourcePlazos" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Vigencia</th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="plazoMeses">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Numero de meses</th>
                                <td mat-cell *matCellDef="let row"> {{row.plazoMeses}} </td>
                            </ng-container>
                            <ng-container matColumnDef="montobase">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio base</th>
                                <td mat-cell *matCellDef="let row"> {{row.montobase | numeropipe}} </td>
                            </ng-container>
                            <ng-container matColumnDef="precio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio IVA incluido</th>
                                <td mat-cell *matCellDef="let row"> {{row.precio | numeropipe}} </td>
                            </ng-container>
                            <ng-container matColumnDef="total">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio total IVA incluido</th>
                                <td mat-cell *matCellDef="let row"> {{row.total | numeropipe}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarPlazos(row)" *ngIf="!editarRegistroPlazos">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarPlazos(row)" *ngIf="!editarRegistroPlazos">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoPlazos"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoPlazos;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorplazos [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabEdades" *ngIf="HabilitarIngresoEdades()">
            <ng-template mat-tab-label>
                <span>Precios del programa</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formEdades" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroEdades">
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formEdades.get('id').value > 0">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Descripción (*)</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off">
                            <mat-error *ngIf="formEdades.get('descripcion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formEdades.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Edad inicio (*)</mat-label>
                            <input matInput formControlName="inicio" autocomplete="off" type="number">
                            <mat-error *ngIf="formEdades.get('inicio').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Edad fin (*)</mat-label>
                            <input matInput formControlName="fin" autocomplete="off" type="number">
                            <mat-error *ngIf="formEdades.get('fin').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Precio (*)</mat-label>
                            <input matInput formControlName="precio" autocomplete="off" type="number">
                            <mat-error *ngIf="formEdades.get('precio').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceEdades" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Vigencia</th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="inicio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Edad inicio</th>
                                <td mat-cell *matCellDef="let row"> {{row.inicio}} </td>
                            </ng-container>
                            <ng-container matColumnDef="fin">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Edad fin</th>
                                <td mat-cell *matCellDef="let row"> {{row.fin}} </td>
                            </ng-container>
                            <ng-container matColumnDef="precio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Precio</th>
                                <td mat-cell *matCellDef="let row"> {{row.precio | numeropipe}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarEdades(row)" *ngIf="!editarRegistroEdades">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarEdades(row)" *ngIf="!editarRegistroEdades">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoEdades"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoEdades;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatoredades [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabCargaCodigos" *ngIf="HabilitarIngresoCodigos()">
            <ng-template mat-tab-label>
                <span>Carga de códigos</span>
            </ng-template>
            <div class="d-flex flex-column">
                <input type="file" multiple #uploadFile [accept]="this.FiltroArchivos" style="display: none;" (change)="ArchivoSeleccionar($event.target.files)">
                <div class="containerupload" appDnd (fileDropped)="ArchivoSeleccionar($event)" *ngIf="!editarRegistroCodigosActivacion">
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
                        <g fill="#3B454F" fill-rule="nonzero">
                            <path
                                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                            <path
                                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                            <path
                                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
                        </g>
                    </svg>

                    <h6>Arrastra y suelta archivos en esta ventana para cargarlos.</h6>
                    <p>Cargue el archivo de respuesta correspondiente</p>
                </div>
                <div [formGroup]="formCodigosActivacion" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroCodigosActivacion">
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formCodigosActivacion.get('id').value > 0">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Descripción (*)</mat-label>
                            <input matInput formControlName="codigo" autocomplete="off">
                            <mat-error *ngIf="formCodigosActivacion.get('codigo').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formCodigosActivacion.get('codigo').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceCodigosActivacion" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="codigo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Código</th>
                                <td mat-cell *matCellDef="let row"> {{row.codigo}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarCodigosActivacion(row)" *ngIf="!editarRegistroCodigosActivacion">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarCodigosActivacion(row)" *ngIf="!editarRegistroCodigosActivacion">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoCodigosActivacion"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoCodigosActivacion;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorcodigos [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabFirmaDocumentos" *ngIf="HabilitarFirmaElectronica()">
            <ng-template mat-tab-label>
                <span>Firma documentos</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formFirmaElectronica" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroFirmaElectronica">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Descripción (*)</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off" type="text">
                            <mat-error *ngIf="formFirmaElectronica.get('descripcion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formFirmaElectronica.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo firma electronica</mat-label>
                            <mat-select formControlName="tipoFirmaElectronica" (ngModelChange)="this.CambioTipoFirma()">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasTipoCodigoOPT">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formFirmaElectronica.get('tipoFirmaElectronica').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Nombre documento</mat-label>
                            <input matInput formControlName="nombreDocumentoFirmaElectronica" autocomplete="off" type="text">
                            <mat-error *ngIf="formFirmaElectronica.get('nombreDocumentoFirmaElectronica').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formFirmaElectronica.get('nombreDocumentoFirmaElectronica').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo fuente datos reemplazo</mat-label>
                            <mat-select formControlName="firmaElectronicaFuente">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasFirmaElectronicaFuente">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formFirmaElectronica.get('firmaElectronicaFuente').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarTipoFirmaElectronicaAuco()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Validar identidad biometrica</mat-label>
                            <mat-select formControlName="firmaElectronicaCamera">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="HabilitarTipoFirmaElectronicaAuco()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Validar código verificación</mat-label>
                            <mat-select formControlName="firmaElectronicaOptCode">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <button mat-button class="botonguardardatos" (click)="CargarArchivoFirmaElectronica(this.formFirmaElectronica.value)" [disabled]="mostrarCargando">
                            <div class="d-flex flex-row-reverse">
                                <mat-icon class="botonguardardatosicono">cloud_upload</mat-icon>
                                <span class="botonguardardatostexto">Adjuntar documento</span>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceFirmaElectronica" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción</th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="rutaArchivoFirmaElectronica">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Archivo firma electronica</th>
                                <td mat-cell *matCellDef="let row"> {{row.rutaArchivoFirmaElectronica}} </td>
                            </ng-container>
                            <ng-container matColumnDef="nombreDocumentoFirmaElectronica">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre documento</th>
                                <td mat-cell *matCellDef="let row"> {{row.nombreDocumentoFirmaElectronica}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarFirmaElectronica(row)" *ngIf="!editarRegistroFirmaElectronica">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarFirmaElectronica(row)" *ngIf="!editarRegistroFirmaElectronica">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="AbrirCamposFirmaElectronica(row)" *ngIf="!editarRegistroFirmaElectronica && row.id > 0">
                                        <mat-icon>view_list</mat-icon>
                                    </a>
                                    <a type="button" (click)="CargarArchivoFirmaElectronica(row)" *ngIf="!editarRegistroFirmaElectronica && row.id > 0">
                                        <mat-icon>cloud_upload</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="DescargarArchivoFirmaElectronica(row)" *ngIf="!editarRegistroFirmaElectronica && row.id > 0">
                                        <mat-icon>cloud_download</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoFirmaElectronica"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoFirmaElectronica;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorfirmaeletronica [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabExpedientes" *ngIf="HabilitarExpedientes()">
            <ng-template mat-tab-label>
                <span>Expedientes</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formExpedientes" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroExpedientes">
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formExpedientes.get('id').value > 0">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listasEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Servicio (*)</mat-label>
                            <mat-select formControlName="idServicio" (ngModelChange)="ObtenerListaSubServicio()">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasServiciosExpedientes">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>SubServicio (*)</mat-label>
                            <mat-select formControlName="idSubServicio">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasSubServiciosExpedientesFiltrada">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Eventos incluidos</mat-label>
                            <input matInput type="number" formControlName="eventosIncluidos" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Monto máximo cobertura</mat-label>
                            <input matInput formControlName="montoMaximoCobertura" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceExpedientes" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row">
                                    <p *ngIf="row.habilitado"><img src="assets/img/activo.svg"></p>
                                    <p *ngIf="!row.habilitado"><img src="assets/img/inactivo.svg"></p>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="servicio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Servicio</th>
                                <td mat-cell *matCellDef="let row"> {{row.servicio}} </td>
                            </ng-container>
                            <ng-container matColumnDef="subServicio">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> SubServicio</th>
                                <td mat-cell *matCellDef="let row"> {{row.subServicio}} </td>
                            </ng-container>
                            <ng-container matColumnDef="eventosIncluidos">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Eventos incluidos</th>
                                <td mat-cell *matCellDef="let row"> {{row.eventosIncluidos}} </td>
                            </ng-container>
                            <ng-container matColumnDef="montoMaximoCobertura">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Monto máximo cobertura</th>
                                <td mat-cell *matCellDef="let row"> {{row.montoMaximoCobertura}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarExpedientes(row)" *ngIf="!editarRegistroExpedientes">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarExpedientes(row)" *ngIf="!editarRegistroExpedientes">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoExpedientes"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoExpedientes;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorexpedientes [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabEstadosDias" *ngIf="HabilitarRegistrarEstadosDias()">
            <ng-template mat-tab-label>
                <span>Estados</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formEstadosDias" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroEstadosDias">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Día mes</mat-label>
                            <input matInput type="number" formControlName="diaMes" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="idEstado">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasEstadosConfiguracion">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Activar siguiente mes (*)</mat-label>
                            <mat-select formControlName="activarSiguienteMes">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Días inactividad</mat-label>
                            <input matInput type="number" formControlName="diaMesActivar" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceEstadosDias" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="dia">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Día mes</th>
                                <td mat-cell *matCellDef="let row"> {{row.diaMes}} </td>
                            </ng-container>
                            <ng-container matColumnDef="estado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                                <td mat-cell *matCellDef="let row"> {{row.estado}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarEstadosDias(row)" *ngIf="!editarRegistroEstadosDias">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarEstadosDias(row)" *ngIf="!editarRegistroEstadosDias">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoEstadosDias"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoEstadosDias;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorestadosdias [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabCampos">
            <ng-template mat-tab-label>
                <span>Campos</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formCampos" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroCampos">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Campo (*)</mat-label>
                            <mat-select formControlName="descripcion">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasCampos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formCampos.get('descripcion').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mostrar</mat-label>
                            <mat-select formControlName="mostrar">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Habilitado</mat-label>
                            <mat-select formControlName="habilitado">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceCampos" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Campo</th>
                                <td mat-cell *matCellDef="let row"> {{this.MostrarDescripcionCampo(row.descripcion)}} </td>
                            </ng-container>
                            <ng-container matColumnDef="mostrar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mostrar</th>
                                <td mat-cell *matCellDef="let row"> {{row.mostrar ? 'SI' : 'NO'}} </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Habilitado</th>
                                <td mat-cell *matCellDef="let row"> {{row.habilitado ? 'SI' : 'NO'}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarCampos(row)" *ngIf="!editarRegistroCampos">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarCampos(row)" *ngIf="!editarRegistroCampos">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoCampos"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoCampos;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorcampos [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabCamposBeneficiarios">
            <ng-template mat-tab-label>
                <span>Campos beneficiarios</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formCamposBeneficiarios" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroCamposBeneficiarios">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Campo (*)</mat-label>
                            <mat-select formControlName="codigo">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasCamposBeneficiarios">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formCamposBeneficiarios.get('codigo').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Descripción (*)</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off" type="text">
                            <mat-error *ngIf="formCamposBeneficiarios.get('descripcion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formCamposBeneficiarios.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Campo padre</mat-label>
                            <mat-select formControlName="origenPadre">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasCamposBeneficiarios">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Orden</mat-label>
                            <input matInput type="number" formControlName="orden" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceCamposBeneficiarios" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="codigo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Campo</th>
                                <td mat-cell *matCellDef="let row"> {{this.MostrarDescripcionCampoBeneficiarios(row.codigo)}} </td>
                            </ng-container>
                            <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción</th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="origenPadre">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Campo padre</th>
                                <td mat-cell *matCellDef="let row"> {{this.MostrarDescripcionCampoBeneficiarios(row.origenPadre)}} </td>
                            </ng-container>
                            <ng-container matColumnDef="orden">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Orden</th>
                                <td mat-cell *matCellDef="let row"> {{row.orden}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarCamposBeneficiarios(row)" *ngIf="!editarRegistroCamposBeneficiarios">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarCamposBeneficiarios(row)" *ngIf="!editarRegistroCamposBeneficiarios">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoCamposBeneficiarios"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoCamposBeneficiarios;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatorcamposbeneficiarios [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabNotificaciones">
            <ng-template mat-tab-label>
                <span>Notificaciones</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formNotificaciones" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroNotificaciones">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo proceso (*)</mat-label>
                            <mat-select formControlName="tipoProceso">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaTipoProceso">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formNotificaciones.get('tipoProceso').hasError('required')">El Tipo proceso es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Enviar SMS</mat-label>
                            <mat-select formControlName="enviarSMS">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Enviar Email</mat-label>
                            <mat-select formControlName="enviarEmail">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Activo</mat-label>
                            <mat-select formControlName="activo">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formNotificaciones" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroNotificaciones">
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-De</mat-label>
                            <input matInput formControlName="emailFrom" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailFrom').hasError('required')">El Email-De es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailFrom').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Copia a</mat-label>
                            <input matInput formControlName="emailReplyTo" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailReplyTo').hasError('required')">El Email-Copia a es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailReplyTo').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Asunto</mat-label>
                            <input matInput formControlName="emailSubject" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailSubject').hasError('required')">El Email-Asunto es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailSubject').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Mensaje</mat-label>
                            <input matInput formControlName="emailMensajeMostrar" autocomplete="off">
                            <button matSuffix mat-icon-button (click)="EditarContenidoHTML()">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <mat-error *ngIf="formNotificaciones.get('emailMensajeMostrar').hasError('required')">El Email-Mensaje es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12" *ngIf="formNotificaciones.get('enviarSMS').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mensaje SMS</mat-label>
                            <input matInput formControlName="smsTexto" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('smsTexto').hasError('required')">El Mensaje SMS es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('smsTexto').hasError('maxlength')">La longitud máxima es 260</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceNotificaciones" matSort class="table table-striped table-hover">

                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <!-- descripcionTipoProceso Column -->
                            <ng-container matColumnDef="descripcionTipoProceso">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo proceso </th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcionTipoProceso}} </td>
                            </ng-container>
                            <!-- enviarSMS Column -->
                            <ng-container matColumnDef="enviarSMS">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Enviar SMS </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.enviarSMS" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- enviarEmail Column -->
                            <ng-container matColumnDef="enviarEmail">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Enviar Email </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.enviarEmail" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- activo Column -->
                            <ng-container matColumnDef="activo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.activo" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- acciones Column -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarNotificaciones(row)" *ngIf="!editarRegistroNotificaciones">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarNotificaciones(row)" *ngIf="!editarRegistroNotificaciones">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoNotificaciones"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoNotificaciones;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatornotificaciones [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0" *ngIf="tabItemSeleccionado === 'tabInformacion' || (tabItemSeleccionado !== 'tabInformacion' && this.form.valid)">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>